import { render, staticRenderFns } from "./finishSurcharge.vue?vue&type=template&id=1f774d9b&scoped=true&"
import script from "./finishSurcharge.vue?vue&type=script&lang=js&"
export * from "./finishSurcharge.vue?vue&type=script&lang=js&"
import style0 from "./finishSurcharge.vue?vue&type=style&index=0&id=1f774d9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f774d9b",
  null
  
)

export default component.exports